import api from './api';

export interface MatiyariLeadPayload {
    name: string;
    phone: string;
}

export const createMatiyariLead = async (payload: MatiyariLeadPayload) => {
    const response = await api.post('/matiyari/leads', {
        name: payload.name.trim(),
        phone: payload.phone.trim(),
    });
    return response.data;
};
